import styled from 'styled-components'
import { colors } from 'shared/styles/colors'

export const ContainerHeader = styled.div`
  position: absolute;
  right: 0px;
`

export const Container = styled.div`
  display: flex;
  align-items: center;

  padding: 10px;

  position: relative;
`

export const SelectedCnpj = styled.span`
  font-size: 14px;
  color: ${colors.white};
`

export const SelectedCnpjRazSoc = styled.span`
  font-size: 14px;
  color: ${colors.white};
  font-weight: 700;
  margin-bottom: 2px;
`

export const ButtonFrotista = styled.button`
  display: flex;
  align-items: center;

  border: none;
  margin-left: 10px;
  background: transparent;
`

export const SelectedFrotista = styled.div`
  padding: 15px;
  border-radius: 50%;
  background: ${colors.blue};
  color: ${colors.white};
  font-weight: 700;

  margin-right: 5px;
`

export const ContainerCnpj = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;

  top: 65px;
  right: 15px;

  padding: 10px;

  background: ${colors.white};

  width: 220px;

  -webkit-box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.4);
  box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.4);

  & > span {
    margin: 10px 0px;
    color: ${colors.black};
    font-size: 13px;
  }

  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;

    max-height: 150px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${colors.blue};
      border-radius: 70px;
    }

    margin: 5px 0px;
    padding-right: 5px;

    & > button {
      display: flex;
      align-items: center;
      border: none;

      width: 100%;

      padding: 5px 0px;
      font-size: 14px;
      color: ${colors.blue};
      font-weight: 700;

      background: transparent;

      & > span {
        margin-left: 10px;
      }

      &.cnpj-frotista {
        border: 1px solid ${colors.grayLight};
        background: transparent;
        color: ${colors.blue};
        font-weight: 700;

        width: 100%;
        padding: 8px;
        border-radius: 4px;

        margin-bottom: 10px;
      }
    }
  }
`

export const ButtonCnpj = styled.button`
  width: 100%;
  padding: 10px;

  background: ${colors.green};

  border: none;

  border-radius: 4px;
  color: ${colors.white};
`

export const ButtonCnpjFrotista = styled.button`
  border: 1px solid ${colors.grayLight};
  background: transparent;
  color: ${colors.blue};
  font-weight: 700;

  width: 100%;
  padding: 8px;
  border-radius: 4px;

  margin-bottom: 10px;
`

export const ContainerSelectedCnpj = styled.div`
  display: flex;
  flex-direction: column;
`
